"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const icon_1 = __importDefault(require("../icon/icon"));
const pressable_1 = __importDefault(require("../pressable/pressable"));
const DefualtProps = {
    icon: free_solid_svg_icons_1.faArrowLeft,
};
const NavigationButton = ({ onPress, event, icon, title }) => {
    return (react_1.default.createElement(pressable_1.default, { onPress: onPress, style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: event },
        icon && (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(icon_1.default, { icon: icon }))),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, title))));
};
NavigationButton.defaultProps = DefualtProps;
exports.default = NavigationButton;
